module.exports = __webpack_public_path__ + "static/media/login-bg.569a1403.png";